export default "__VITE_ASSET__CQcfJgvw__"